import { createReducer, on } from '@ngrx/store';
import { FlattenGraphQl } from 'src/app/utility';
import { CreateCustomerData, Customer, CustomerAccessToken, ShopifyError, Profile, MailingAddress } from '../../models';
import { Order, OrderLineItem } from '../../models/order.model';

import * as actions from '../actions/tax-exemptions.action';
import * as utility from '../../../utility';
export interface TaxExemptionsState {
  result: { success: boolean; valid: boolean; status: number } | null;
  checking: boolean;
  checked: boolean;
  valid: boolean;
  errors?: any;
}

export const initialState: TaxExemptionsState = {
  result: null,
  checking: false,
  checked: false,
  valid: false,
};

export const taxExemptionsReducer = createReducer(
  initialState,
  on(actions.CheckTaxExemptions, (state: TaxExemptionsState) => {
    return {
      ...state,
      checking: true,
      checked: false,
      valid: false,
      errors: [],
    };
  }),
  on(actions.CheckTaxExemptionsSuccess, (state: TaxExemptionsState, { result }) => {
    return {
      ...state,
      result,
      checked: true,
      checking: false,
      valid: result.valid,
      errors: [],
    };
  }),
  on(actions.CheckTaxExemptionsFail, (state: TaxExemptionsState, { errors }) => {
    return {
      ...state,
      checked: false,
      checking: false,
      valid: false,
      errors,
    };
  }),
  on(actions.ResetTaxExemptionsCheck, (state: TaxExemptionsState) => {
    return {
      ...initialState,
    };
  })
);

export const getExemptionResult = (state: TaxExemptionsState) => state.result;
export const getExemptionValid = (state: TaxExemptionsState) => state.valid;
export const getExemptionChecking = (state: TaxExemptionsState) => state.checking;
export const getExemptionChecked = (state: TaxExemptionsState) => state.checked;
export const getExemptionErrors = (state: TaxExemptionsState) => state.errors;
